import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";

export class RewardAnyContactBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerOutput("contact", RewardGraphConnectionPointTypes.Boolean);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardAnyContactBlock";
    }

    /**
     * Gets the output component
     */
    public get contact(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    protected override _buildBlock() {
        this.contact._storedFunction = (state) => {
            return false;
        };
        return this;
    }
}

RegisterClass("MELS.RewardAnyContactBlock", RewardAnyContactBlock);
